import React from "react";
import { AdmissionsCoordinatorsLeadsSplitview } from "../components/splitviews/ac-leads-splitview";

export function AdmissionsCoordinatorsKPIsDashboardPage(props) {
  return <AdmissionsCoordinatorsLeadsSplitview {...props} />;
}
